<template>
  <Modal
    modalId="directory-create"
    ref="createDirectory"
    :className="'margin-top'"
  >
    <div
      slot="modal-header"
      class="emphasis"
    >{{ $t('directory.msg.selectType') }}</div>
    <div
      slot="content"
      class="content"
    >
      <HKLSelect
        :options="typeOptions"
        :showSearch="true"
        :value="selectedType"
        placeholder=""
        @change="val => selectedType = val"
      />
    </div>
    <div slot="btns">
      <button
        type="button"
        class="btn btn--orange"
        :disabled="!selectedType"
        @click="_createDirectory"
      > {{ $t('action.create') }} </button>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Modal from '@/controls/Modal'
import HKLSelect from '@/controls/Select/HKLSelect'

import { directoryRouteNames } from '@/utils/consts'
import navigation from '@/utils/navigation'
import notification from '@/utils/notification'
import { DIR_ACTION, DIR_TYPE, DIR_COMP_TYPE } from './consts'

export default {
  name: 'createDirectoryModal',
  components: {
    Modal,
    HKLSelect,
  },
  props: {
    tenancyId: {
      type: [String, Number],
      default: '',
    },
  },

  data () {
    return {
      typeOptions: Object.values(DIR_TYPE),
      selectedType: '',
    }
  },

  methods: {
    ...mapActions('directories', ['createDirectory']),
    open () {
      this.$refs['createDirectory'].open()
    },
    async _createDirectory () {
      if (!this.tenancyId) {
        notification.warn(this.$t('directory.msg.invalidTenancyId'))
        return
      }
      try {
        const directory = await this.createDirectory({
          tenancyId: this.tenancyId,
          type: this.selectedType,
          companies: [{
            type: DIR_COMP_TYPE.MAIN,
          }],
          action: DIR_ACTION.ADD,
        })

        this.$refs['createDirectory'].close()
        const toPage = this.isTenant ? directoryRouteNames.tenantDirectoryDetail : directoryRouteNames.directoryDetail
        navigation.toPage(toPage, { id: directory.id })
      } catch (error) {
        // do nothing
      }
    },
  },
  computed: {
    ...mapGetters('user', ['isTenant']),
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/common';

.content {
  padding: 20px 0;
}
</style>
